<template>
  <div class="MyLoadLeft">
    <div v-if="creditSuccessList.length !== 0">
      <div
        class="loadingBox"
        v-if="IsloadingBox"
      >
        <Loading
          accountFont="加载中..."
          color="#fff"
          type="spinner"
        ></Loading>
      </div>
      <div class="left">
        <!-- 贷款产品 -->
        <div class="left_swipe">
          <!-- <van-swipe
            :show-indicators="false"
            @change="onChange"
          > -->
          <van-tabs v-model="current" @change="onChange" swipe-threshold="1" class="swipe-item">
            <van-tab 
              v-for="(e, index) in creditSuccessList"
              :key="index" :title="e.productName">
              <my-load-swipe-item
                :current="index"
                :creditSucceinfo="result"
                :maxLength="creditSuccessList.length"
              ></my-load-swipe-item>
            </van-tab>
            <!-- <van-swipe-item
              v-for="(e, index) in creditSuccessList"
              :key="e.orderId"
              class="swipe-item"
            > -->
              

          </van-tabs>
            <!-- </van-swipe-item> -->
          <!-- </van-swipe> -->
        </div>
        <!-- 资金账户 -->
        <div
          v-if="isShow"
          class="account_content"
        >
          <span class="account_content_text">贷款相关金额若有偏差，请最终以银行为准。</span>
          <div
            class="accountBox"
            @click="goToCapitalaccount"
          >
            资金账户
          </div>
        </div>
        <!-- <div v-if="isChangeCardNumber" class="account_content">
        <div class="accountBox" @click="goToChangeCardNumber">
          变更还款卡号
          <i class="iconfont icon-you icon_account"></i>
        </div>
      </div> -->
        <!-- 提款记录 -->
        <div class="loanrecords">提款记录</div>
        <MyLoadSuccessList :list="result"></MyLoadSuccessList>
      </div>
    </div>
    <div
      class="nodata"
      v-if="creditSuccessList.length === 0"
    >
      <img
        src="@/assets/images/nodata.png"
        alt=""
      >
      <p>
        这里什么都没有，快<span
          style="color:#F56446;"
          @click="goTofinancing"
        >去填写融资申请</span>吧！
      </p>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue';
import MyLoadSwipeItem from './MyloadSwipeItem.vue';
import MyLoadSuccessList from './MyLoadSuccessList.vue';

export default {
  name: 'MyLoadLeft',
  components: {
    MyLoadSwipeItem,
    MyLoadSuccessList,
    Loading,
  },
  data() {
    return {
      current: 0,
      isShow: false,
      result: {},
      IsloadingBox: false,
      ShowContent: '',
      isChangeCardNumber: false,
    };
  },
  props: ['creditSuccessList'],
  watch: {
    creditSuccessList: {
      handler(val) {
        if (val.length === 0) return;
        const { orderId } = val[this.current];
        this.getCreditSuccessInfo(val[this.current]);
        this.isChangeCardNumber = val[this.current].productId !== 'SPDB-FPD';
        this.hasFundAccount(orderId);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    creditSuccessOrderId() {
      return this.creditSuccessList.filter((e) => (e.productId === this.result.productId))[0].orderId;
    },
  },
  methods: {
    onChange(index) {
      console.log(1234567890,index,this.current)
      // this.current = index;
      if (this.creditSuccessList.length === 0) return;
      const { orderId } = this.creditSuccessList[index];
      this.hasFundAccount(orderId);
      this.getCreditSuccessInfo(this.creditSuccessList[index]);
    },
    hasFundAccount(orderId) {
      this.$api.PublicPage.hasFundAccount({ orderId })
        .then((res) => {
          if (res.success) {
            const { data } = res;
            this.isShow = data.isShow;
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.returnMessage,
            });
          }
        })
        .catch((e) => {
          this.IsloadingBox = false;
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
    getCreditSuccessInfo({ orderId, productId }) {
      this.$api.PublicPage.getCreditSuccessInfo({
        orderId,
        productId,
      })
        .then((res) => {
          if (res.success) {
            const { data } = res;
            this.result = data;
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.returnMessage,
            });
          }
          this.IsloadingBox = false;
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
          this.IsloadingBox = false;
        });
    },
    goToCapitalaccount() {
      localStorage.setItem('orderId', this.creditSuccessOrderId);
      this.$router.push('/supermarket/v2/Capitalaccount');
    },
    goToChangeCardNumber() {
      this.$router.push('/supermarket/v2/ChangeCardNumber');
    },
    goTofinancing() {
      this.$router.push('/supermarket/v2/');
    },
  },
};
</script>
<style scoped>
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}
.left_swipe {
  padding: 16px;
}
.left_swipe img {
  height: 250px;
}
/* .swipe-item {
  background: #fff;
} */
.swipe-item >>> .van-tabs__wrap{
  margin-bottom: 16px;
}
.MyLoadLeft >>> .custom-indicator {
  display: none;
}
.accountBox {
  background: #ffffff;
  height: 16px;
  box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  margin-bottom: 16px;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #bd895a;
}
.account_content {
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding: 0 16px;
}
.account_content_text {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #9b9b9b;
  margin: 7px 0 7px 0;
}
.loanrecords {
  margin-top: 16px;
  background: #fff;
  font-size: 17px;
  font-weight: bold;
  height: 45px;
  text-align: left;
  line-height: 45px;
  padding-left: 16px;
}
.loadingBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.nodata {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  padding: 40px 0;
  color: #9ea7b4;
}
.nodata img {
  width: 100%;
}
.icon_account {
  color: #989a9c;
  font-size: 22px;
}
</style>
